// This file is auto-generated by @hey-api/openapi-ts

/**
 * Eshop order state
 */
export const OrderStateEnum = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
    RETURNED: 'RETURNED',
    PROCESSING: 'PROCESSING'
} as const;

/**
 * Eshop order state
 */
export type OrderStateEnum = typeof OrderStateEnum[keyof typeof OrderStateEnum];
